export default __webpack_public_path__ + "static/media/keep.2600eba2.png";